import { useCallback } from "react";

import { IMessageId, ILocalizable } from "infrastructure/localization";

import { useLocalizer, isMessageId } from "./useLocalizer";

// return function that must be used only when localizable data can have value that do not possible
// localize in some cases but must be localized in others (error from server that can be absent if everything is ok)
export function useLocalizerWithFallback() {
  const localize = useLocalizer();

  const localizer = useCallback(
    (dataToLocalize?: ILocalizable | IMessageId | string, fallbackValue?: string) => {
      if (dataToLocalize) {
        if (typeof dataToLocalize === "string") {
          return fallbackValue ?? dataToLocalize;
        } else {
          try {
            if (isMessageId(dataToLocalize)) {
              return localize(dataToLocalize);
            } else {
              return localize(dataToLocalize.messageId, dataToLocalize.tokens);
            }
          } catch (error) {
            return fallbackValue || undefined;
          }
        }
      } else {
        return fallbackValue || undefined;
      }
    },
    [localize]
  );

  return localizer;
}
